module.exports = __webpack_public_path__ + "static/media/ophos-race.15e29175.svg";